import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import 'bootstrap-icons/font/bootstrap-icons.css';
import HHlogo from '../HHlogo.png';
import '../main.css';

function AppNav() {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/high-school/contact');
    setExpanded(false);
  };

  return (
    <Navbar expand="lg" expanded={expanded} className="custom-navbar" sticky="top">
      <Container>
        {/* Brand Logo */}
        <Navbar.Brand as={Link} to="/high-school" className="d-flex align-items-center">
          <img
            src={HHlogo}
            alt="HH Logo"
            className="navbar-logo d-inline-block align-top me-2"
            style={{ height: '40px' }}
          />
          <span className="text-white fw-bold">HIGHLANDS</span>
        </Navbar.Brand>

        {/* Toggler */}
        <Navbar.Toggle
          aria-controls="navbar-nav"
          onClick={() => setExpanded(!expanded)}
          className={`custom-toggler ${expanded ? 'open' : ''}`}
        />

        {/* Links */}
        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto ms-auto d-flex align-items-center gap-3">
            <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>HOME</Nav.Link>
            <Nav.Link as={Link} to="/high-school/academics" onClick={() => setExpanded(false)}>ACADEMICS</Nav.Link>
            <Nav.Link as={Link} to="/high-school/our-pillars" onClick={() => setExpanded(false)}>OUR PILLARS</Nav.Link>
            <Nav.Link as={Link} to="/high-school/facilities" onClick={() => setExpanded(false)}>FACILITIES</Nav.Link>
            <Nav.Link as={Link} to="/high-school/how-to-pay" onClick={() => setExpanded(false)}>FEES</Nav.Link>
          </Nav>

          {/* Contact Button and Icons */}
          <div className="d-flex align-items-center gap-3">
            <Button variant="outline-light" onClick={handleContactClick}>
              SEND US A QUERY
            </Button>

            <div className="d-flex gap-3">
              <OverlayTrigger placement="bottom" overlay={<Tooltip>Call: 061 545 4633</Tooltip>}>
                <i className="bi bi-telephone contact-icon text-white fs-5"></i>
              </OverlayTrigger>

              <OverlayTrigger placement="bottom" overlay={<Tooltip>Email: admin@highlandscollege.co.za</Tooltip>}>
                <i className="bi bi-envelope-at contact-icon text-white fs-5"></i>
              </OverlayTrigger>

              <OverlayTrigger placement="bottom" overlay={<Tooltip>WhatsApp: 061 545 4633</Tooltip>}>
                <i className="bi bi-whatsapp contact-icon text-white fs-5"></i>
              </OverlayTrigger>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppNav;
